<template>
  <div class="component-form">
    <h1 class="form-title">Summer Communication</h1>
    <p class="text big bold mt-30">Will you be unable to communicate with us at any point over the summer?</p>
    <RadioGroup
      class="mt-10 checkboxgroup-wrap inp-wrap large"
      :options="GROUP_OPTIONS"
      :value="value.can_communicate"
      @input="handleInput($event, 'can_communicate')"
    />
    <p class="text bold big mt-30">If so, please give the dates and reason you'll be unavailable.</p>
    <div class="inp-wrap mt-20 large">
      <Textarea :counter="false" placeholder="" :value="value.reason" @input="handleInput($event, 'reason')" />
    </div>
    <p class="text bold big mt-30">Please provide the best emergency communication method for the summer.</p>
    <p class="text mt-10">Phone, WeChat, Facebook, etc.</p>
    <div class="inp-wrap mt-20 large">
      <Textarea :counter="false" placeholder="" :value="value.communication_method" @input="handleInput($event, 'communication_method')" />
    </div>
    <Button class="btn-submit" @click="handleClickSubmit">Submit</Button>
  </div>
</template>
<script>
import { Button } from '../../../../components/form';
import Textarea from '../../../../components/form/Textarea/Prototype';
import RadioGroup from '../../../../components/form/RadioGroup/Prototype';
const GROUP_OPTIONS = [
  {
    label: 'Yes',
    value: 'Yes'
  },
  {
    label: 'No',
    value: 'No'
  }
];
export default {
  name: 'SummerCommunication',
  components: {
    Button,
    RadioGroup,
    Textarea
  },
  props: {
    value: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  computed: {
    GROUP_OPTIONS() {
      return GROUP_OPTIONS;
    }
  },
  methods: {
    handleInput: function(value, name) {
      this.$emit('input', {
        ...this.value,
        [name]: value
      });
    },
    handleClickSubmit: function() {
      this.$emit('submit');
    }
  }
};
</script>
